module.exports = __webpack_public_path__ + "img/money_rain_rewards.bf72c704.svg";